

// Backend apis url domains
export const NIYUKTI_API = process.env.REACT_APP_NIYUKTI_API;
export const PRAVESH_API = process.env.REACT_APP_PRAVESH_API;
export const SUJHAV_API = process.env.REACT_APP_SUJHAV_API;
export const SANDESH_API = process.env.REACT_APP_SANDESH;

export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
export const websiteRegex =
  /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
export const websiteRegexNew =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;

export const IndianNumberRegex = /^[0]?[6789]\d{9}$/;

